<template>
  <div class="login">
    <div class="loginBox">
      <div class="title">
        <!-- <strong>欢迎登录</strong> -->
        <strong>{{ $t("login.huanyin") }}</strong>
      </div>
      <div class="inputBox">
        <img src="../assets/images/user.png" alt="s" class="limg" />
        <input
          type="text"
          v-model="form.userName"
          :placeholder="$t('login.zhanghao')"
        />
      </div>
      <div class="inputBox">
        <img src="../assets/images/user.png" alt="s" class="limg" />
        <input
          type="password"
          v-model="form.userPwd"
          :placeholder="$t('login.mima')"
        />
      </div>
      <div class="inputBox">
        <img src="../assets/images/user.png" alt="s" class="limg" />
        <input
          type="text"
          v-model="form.code"
          :placeholder="$t('login.yanzhenma')"
        />
        <img :src="img" class="imgCode" alt="" />
      </div>
      <div class="but" @click="login()">
        {{ $t("login.login") }}
      </div>
      <div class="ft">
        <div class="fl">
          {{ $t("login.haimei") }},<span class="lan" @click="goRegister()">{{
            $t("login.quzhuce")
          }}</span>
        </div>
        <div class="fr" @click="goPassword()">
          {{ $t("login.wangji") }}
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  // created() {
  //   this.enterLogin();
  // },

  data() {
    return {
      form: {
        code: "",
        userName: "",
        userPwd: "",
        uuid: "",
      },
      img: "",
    };
  },

  mounted() {
    // document.addEventListener("keydown", function(e) {
    //   if (e.key === "F12" || e.keyCode === 123) {
    //     e.preventDefault();
    //   }
    // });
    // document.addEventListener("contextmenu", function(e) {
    //   e.preventDefault();
    // });


    //绑定事件
    // window.addEventListener('keydown',this.keyDown);
    this.getCode();
  },
  methods: {
    // keyDown(e){
    //     //如果是回车则执行登录方法
    //   if(e.keyCode == 13){
    //     this.login();
    //   }
    // }
    // 前往注册
    goRegister() {
      this.$router.push("/register");
    },
    // 前往忘记密码
    goPassword() {
      this.$router.push("/password");
    },
    // 前往个人
    async login() {
      let { data: res } = await this.$http.post("/c/login", this.form);
      if (res.code != 200) {
        return this.$message.error(res.message);
      }
      window.sessionStorage.setItem("Authorization", res.data);

      this.$router.push("/personal");
      // window.location.href = "#/personal";
    },
    // 获取验证码
    async getCode() {
      let { data: res } = await this.$http.get("/c/code");
      if (res.code != 200) {
        return;
      }
      this.form.uuid = res.data.uuid;
      this.img = res.data.img;
    },
  },
};
</script>

<style lang="less" scoped>
.login {
  height: 43.75rem;
  background-color: #f1f1f1;
  padding-top: 10rem;
  background-image: url("../assets/images/logBg.jpg");
  background-size: cover;
  background-repeat: no-repeat;
  .loginBox {
    width: 27.5rem;
    height: 28.125rem;
    background-color: #fff;
    margin: 0 auto 0;
    border-radius: 0.9375rem;
    padding: 1.875rem;
    box-sizing: border-box;
    .title {
      text-align: center;
      font-size: 1.375rem;
      margin-bottom: 0.625rem;
    }
    .inputBox {
      border-bottom: 0.0313rem solid #ccc;
      height: 4.0625rem;
      .limg {
        width: 1.25rem;
        height: 1.25rem;
        margin-right: 0.625rem;
      }
      input {
        width: calc(100% - 11.25rem);
        line-height: 4.0625rem;
        outline: none;
        border: none;
      }
      .imgCode {
        display: inline-block;
        float: right;
        margin-top: 0.625rem;
        width: 6.25rem;
        height: 2.5rem;
        // padding: .625rem;
        text-align: center;
        background-color: #f1f1f1;
      }
    }
    .but {
      height: 3.125rem;
      background-color: rgb(67, 188, 183);
      text-align: center;
      line-height: 3.125rem;
      color: #fff;
      margin-top: 1.875rem;
      border-radius: 0.3125rem;
    }
    .ft {
      margin-top: 1.875rem;
      .lan {
        color: rgb(67, 188, 183);
      }
      .fr {
        color: rgb(148, 13, 13);
      }
    }
  }
}
</style>
